// Extract nested keys into dot-separated strings
import get from 'lodash/get.js'

type CreateDotStrings<T, P extends string = ''> = {
  [K in keyof T]: T[K] extends object
    ? T[K] extends unknown[]
      ? never // Ignore arrays
      : `${P}${string & K}.${CreateDotStrings<T[K], P>}`
    : `${P}${string & K}`
}[keyof T]

// Filter dot-separated keys to only keep those that end in .active and strip .active from the returned name
export type AvailableFeatures<T> = {
  [K in CreateDotStrings<T>]: K extends `${infer Rest}.active` ? Rest : never
}[CreateDotStrings<T>]

type Value = boolean | string | number | object | string[]

type FeatureDef = {
  active: boolean
} & {
  [key: string]: Value | FeatureDef
}

type Features = Record<string, FeatureDef>

type ConfigWithFeatures = Record<string, Value> & {
  features: Features
}

export const isFeatureKeyEnabled = (featureKey: string, configToCheck: ConfigWithFeatures): boolean => {
  const isActive = featureKey
    .split('.')
    .reduce((acc, _, index, original) => [...acc, original.slice(0, index + 1).join('.')], [])
    .map((key) => get(configToCheck, `features.${key}`))
    .every((value) => !!(value as FeatureDef)?.active)

  return isActive
}
